import React, { useContext, useState } from "react";
import "./PrismTheme.css";

import {
  MenuOutlined,
  QrcodeOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { downArrow, upArrow } from "../Common/SvgIcon";
import { swipeUparrow, swipeDown1 } from "../Common/SvgIcon";
import {
  defaultBackgroundImage,
  defaultProfileImage,
} from "../Common/DefaultImage";
import { FloatButton } from "antd";
import { FaExchangeAlt, FaLocationArrow } from "react-icons/fa";
// import QRModal from "../Common/QRModal";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import SlideSocialMedia from "../Common/socialMedia/SlideSocialMedia";
import { HighlightImageValid, SocialMediaValid } from "../Common/DivValidation";
import { Link } from "react-router-dom";
import ProfileCardUltra from "../Common/profileCards/ProfileCardUltra";
import ProfileCardGlassy from "../Common/profileCards/ProfileCardGlassy";
import WebsiteUltra from "../Common/websiteCards/WebsiteUltra";
import ReviewCardUltra from "../Common/reviewCards/ReviewCardUltra";
import DownloadCardUltra from "../Common/fileDownloadsCards/DownloadCardUltra";
import ContactCardGlassy from "../Common/contactCards/ContactCardGlassy";
import SlideSocialMedias from "../Common/socialMedia/SlideSocialMedias";
import WebsiteBasic from "../Common/websiteCards/WebsiteBasic";
import VerticalSlideSMVex from "../Common/socialMedia/VerticalSlideSMVex";
import ReviewCardBasic from "../Common/reviewCards/ReviewCardBasic";

import DownloadBasic from "../Common/fileDownloadsCards/DownloadBasic";
import ProfileCardPrism from "../Common/profileCards/ProfileCardPrism";
import ContactCardPrism from "../Common/contactCards/ContactCardPrism";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import { CardContext } from "../../store/CardContext";
import Footer from "../Common/footer/Footer";
import QRModal from "../Common/qrModals/QRModal";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../helpers/tapCountMutation";

// import SlideSocialMedias from '../Common/socialMedia/SlideSocialMedias';


const exchangeButton = (

  <span
    className="flex items-center justify-center "

  >
    <FaExchangeAlt size={14} color="black" />
  </span >
)


function PrismTheme({ preview, card }) {



  const [cardData] = useContext(CardContext)

  const {
    profileImage,
    backgroundImage,
    personalDetails,
    checkProfile,
    contactDetails,
    socialMedias,
    website,
    review,
    fileName,
    files,
    SMediaPostion,
    companyLogo,
    checkLogo,
    vCard,
    checkExchangeContact,
    exchangeContact,
    footerText
  } = cardData



  // const files = {
  //   file1: file1,
  //   file2: file2,
  //   file3: file3,
  //   file4: file4,
  // };

  const [isExpanded, setIsExpanded] = useState(false);
  const [qrModal, setQrModal] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZEEQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  const handleClose = (e) => {
    setQrModal(false);
  };

  const HighlightImageCheck = HighlightImageValid();
  const SocialMediaImageCheck = SocialMediaValid();


  // const pfImage = profileImage?.thumbUrl &&
  //   profileImage?.status !== "removed" ? (
  //   profileImage?.originFileObj?.type
  //     ? URL.createObjectURL(
  //       profileImage?.originFileObj
  //     )
  //     : profileImage[0].thumbUrl
  // ) : defaultProfileImage

  const pfImage = profileImage ? profileImage : defaultProfileImage

  const imageStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: `url(${pfImage})`,
    backgroundRepeat: "no-repeat",
    // backgroundAttachment: "sticky"
  };


  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };


  return (
    <>

      <div className="digitalcontainer6 ">
        <div className="digitalcontainer_center6  ">
          {/* BAckground image */}
          <div className="digitalcontainer_banner6 relative h-screen overflow-auto scrollbar-hide bg-black "
          // style={imageStyle}
          >
            <div className="relative">
              <div className="w-[53px] h-[53px] absolute top-[380px] left-[5px] bg-[#289C85] bg-opacity-80 rounded-[50%] ">
                <div className="w-[30px] h-[30px] absolute top-[60px] left-[10%] rounded-[50%] bg-opacity-80 bg-white "></div>
              </div>
            </div>

            <div className="relative">
              <div className="w-[100px] h-[100px] absolute top-[550px] right-[0px] bg-[#289C85]  bg-opacity-80 rounded-[50%]">
                <div className="w-[48px] h-[48px] absolute top-[80px] left-[35%] rounded-[50%] bg-opacity-80 bg-white"></div>
              </div>
            </div>
            {/* 
{isExpanded && (
  <div className="relative ">
  <div className="w-[100px] h-[100px] absolute top-[1140px] left-0 bg-[#289C85] bg-opacity-80 rounded-full">
    <div className="w-[48px] h-[48px] absolute top-[30px] left-[0%] rounded-full bg-opacity-80 bg-white"></div>
  </div>
</div>
)} */}

            <div className='w-[290px] h-[350px] overflow-hidden' style={{ borderTopRightRadius: '157px', borderBottomRightRadius: '157px' }}>
              {/* {profileImage[0]?.thumbUrl && profileImage[0]?.status !== "removed" ? (
                <img
                  className='sticky top-0 w-full h-full object-cover'
                  src={
                    profileImage[0]?.originFileObj?.type
                      ? URL.createObjectURL(profileImage[0]?.originFileObj)
                      : profileImage[0].thumbUrl
                  }
                  alt=""
                  style={{ borderTopRightRadius: '157px', borderBottomRightRadius: '157px' }}
                />
              ) : ( */}

              {/* Profile image */}
              <img
                className='sticky w-full h-full object-cover'
                src={profileImage ? profileImage : defaultProfileImage}
                alt=""
                style={{ borderRadius: '30px' }}
              />
              {/* )} */}
            </div>

            <div className="glassythemedetails">
              <div className="flex justify-end">

                <div className="fixed top-5 m-5">
                  <div>
                    <Link className="flex gap-2 h-[40px] "
                      to={`${preview ? contactDetails?.locationUrl : ""}`}
                      target={`${preview ? "_blank" : ""}`}
                    >
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.11425 10.0068H7.1611C6.6431 10.0068 6.14631 10.2126 5.78002 10.5789C5.41374 10.9451 5.20796 11.4419 5.20796 11.9599V21.335C5.20796 21.853 5.41374 22.3498 5.78002 22.7161C6.14631 23.0824 6.6431 23.2882 7.1611 23.2882H18.88C19.398 23.2882 19.8948 23.0824 20.2611 22.7161C20.6274 22.3498 20.8331 21.853 20.8331 21.335V11.9599C20.8331 11.4419 20.6274 10.9451 20.2611 10.5789C19.8948 10.2126 19.398 10.0068 18.88 10.0068H16.9268M9.11425 6.88176L13.0205 2.97546M13.0205 2.97546L16.9268 6.88176M13.0205 2.97546V16.3057" stroke="white" stroke-width="1.56252" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </Link>
                  </div>
                  <div className="flex fixed top-[280px] justify-end pr-2">
                    <div className="">
                      {/* <div className="pb-3">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="20" cy="20" r="20" fill="white" />
                          <rect width="24" height="24" transform="translate(8 8)" fill="white" />
                          <path d="M23.75 23.75H27.5V27.5H23.75V23.75ZM20.75 20.75H23.75V23.75H20.75V20.75ZM27.5 27.5H30.5V30.5H27.5V27.5ZM28.25 20.75H30.5V23H28.25V20.75ZM20.75 28.25H23V30.5H20.75V28.25ZM23.75 12.5H27.5V16.25H23.75V12.5Z" fill="black" />
                          <path d="M30.5 19.25H20.75V9.5H30.5V19.25ZM22.8125 17.1875H28.4375V11.5625H22.8125V17.1875ZM12.5 12.5H16.25V16.25H12.5V12.5Z" fill="black" />
                          <path d="M19.25 19.25H9.5V9.5H19.25V19.25ZM11.5625 17.1875H17.1875V11.5625H11.5625V17.1875ZM12.5 23.75H16.25V27.5H12.5V23.75Z" fill="black" />
                          <path d="M19.25 30.5H9.5V20.75H19.25V30.5ZM11.5625 28.4375H17.1875V22.8125H11.5625V28.4375Z" fill="black" />
                        </svg>

                      </div> */}
                      <div>
                        {/* <Link className="" to={`${preview ? vCard : ""}`}>
                          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2_77)">
                              <path d="M22 18V10H18V18H10V22H18V30H22V22H30V18H22ZM20 40C14.6957 40 9.60859 37.8929 5.85786 34.1421C2.10714 30.3914 0 25.3043 0 20C0 14.6957 2.10714 9.60859 5.85786 5.85786C9.60859 2.10714 14.6957 0 20 0C25.3043 0 30.3914 2.10714 34.1421 5.85786C37.8929 9.60859 40 14.6957 40 20C40 25.3043 37.8929 30.3914 34.1421 34.1421C30.3914 37.8929 25.3043 40 20 40Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_2_77">
                                <rect width="40" height="40" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                        </Link> */}

                        <Link
                          onClick={() => handleTap('saveContact')}
                          to={`${preview ? vCard : ''}`}
                        >

                          <svg width="40" height="40" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22.8046" cy="22.8046" r="20.8046" fill="white" />
                            <circle cx="22.8046" cy="22.8046" r="21.8046" stroke="white" stroke-opacity="0.4" stroke-width="2" />
                            <g clip-path="url(#clip0_365_121)">
                              <path d="M26.8047 24.8047C28.1308 24.8047 29.4025 25.3315 30.3402 26.2692C31.2779 27.2068 31.8047 28.4786 31.8047 29.8047V30.8047C31.8047 31.3351 31.594 31.8438 31.2189 32.2189C30.8438 32.594 30.3351 32.8047 29.8047 32.8047H15.8047C15.2743 32.8047 14.7655 32.594 14.3905 32.2189C14.0154 31.8438 13.8047 31.3351 13.8047 30.8047V29.8047C13.8047 28.4786 14.3315 27.2068 15.2692 26.2692C16.2068 25.3315 17.4786 24.8047 18.8047 24.8047H26.8047ZM30.8047 18.8047C31.0699 18.8047 31.3243 18.91 31.5118 19.0976C31.6993 19.2851 31.8047 19.5395 31.8047 19.8047V20.8047H32.8047C33.0699 20.8047 33.3243 20.91 33.5118 21.0976C33.6993 21.2851 33.8047 21.5395 33.8047 21.8047C33.8047 22.0699 33.6993 22.3243 33.5118 22.5118C33.3243 22.6993 33.0699 22.8047 32.8047 22.8047H31.8047V23.8047C31.8047 24.0699 31.6993 24.3243 31.5118 24.5118C31.3243 24.6993 31.0699 24.8047 30.8047 24.8047C30.5395 24.8047 30.2851 24.6993 30.0976 24.5118C29.91 24.3243 29.8047 24.0699 29.8047 23.8047V22.8047H28.8047C28.5395 22.8047 28.2851 22.6993 28.0976 22.5118C27.91 22.3243 27.8047 22.0699 27.8047 21.8047C27.8047 21.5395 27.91 21.2851 28.0976 21.0976C28.2851 20.91 28.5395 20.8047 28.8047 20.8047H29.8047V19.8047C29.8047 19.5395 29.91 19.2851 30.0976 19.0976C30.2851 18.91 30.5395 18.8047 30.8047 18.8047ZM22.8047 12.8047C24.1308 12.8047 25.4025 13.3315 26.3402 14.2692C27.2779 15.2068 27.8047 16.4786 27.8047 17.8047C27.8047 19.1308 27.2779 20.4025 26.3402 21.3402C25.4025 22.2779 24.1308 22.8047 22.8047 22.8047C21.4786 22.8047 20.2068 22.2779 19.2692 21.3402C18.3315 20.4025 17.8047 19.1308 17.8047 17.8047C17.8047 16.4786 18.3315 15.2068 19.2692 14.2692C20.2068 13.3315 21.4786 12.8047 22.8047 12.8047Z" fill="#530404" />
                            </g>
                            <defs>
                              <clipPath id="clip0_365_121">
                                <rect width="24" height="24" fill="white" transform="translate(10.8047 10.8047)" />
                              </clipPath>
                            </defs>
                          </svg>

                        </Link>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`bg-[#D9D9D933]  m-[15px]   left-0 right-0 transform transition-transform ease-in-out  absolute  duration-300 ${isExpanded ? "translate-y-0 m-0 top-[0px]  " : "translate-y-0 top-[300px]"
                  }`}
                style={{ borderTopRightRadius: '184px', borderTopLeftRadius: '184px' }}    >
                <div className="profilecard6  justify-between" style={{ marginTop: "-1px" }}>
                  <div className="flex justify-center pt-10 items-center">
                    <div className="cursor-pointer" onClick={toggleExpand}>
                      {isExpanded ? swipeDown1 : swipeUparrow}
                    </div>
                  </div>

                  <div className="info border-b-[1px] text-[23px] border-white m-[15px]">
                    <ProfileCardPrism preview={preview} textStyle={{ display: "flex", justifyContent: "center", alignItems: "center" }} />
                  </div>

                  <div className="border-b-[1px] m-[20px] border-white">
                    <ContactCardPrism preview={preview} />
                  </div>


                  {isExpanded && (
                    <div>


                      <div className={`m-[20px] border-b-[1px] ${!personalDetails?.about && 'hidden'}`}>
                        <p className="text-white text-[19px] font-bold text-center">About</p>
                        {personalDetails?.about && (
                          <div className="text-center">
                            <p className="text-white text-[12px] font-medium whitespace-pre-line">
                              {personalDetails?.about}
                            </p>
                          </div>
                        )}
                      </div>


                      <div className={`${(website[0]?.websiteName || review[0]?.reviewName || (socialMedias && socialMedias.length !== 0)) ? 'border-b-[1px] border-white m-[15px]' : ''}`}>
                        <div className="flex mt-[20px] gap-2">
                          {website[0]?.websiteName ? (

                            <div className=" w-1/2  overflow-auto scrollbar-hide mb-2  items-center   ">
                              <div className="flex items-center justify-center h-[54px] ">
                                <p className="text-[18px] text-white font-semibold h-[0px]  text-center">
                                  Website
                                </p>
                              </div>
                              <div className="flex justify-center">
                                <WebsiteBasic preview={preview} color={'white'} />
                              </div>
                            </div>

                          ) : (
                            ""
                          )}

                          {review[0]?.reviewName ? (
                            <div className="w-1/2   overflow-auto scrollbar-hide mb-2   items-center   ">
                              <div className="flex items-center justify-center h-[54px] ">
                                <p className="text-[18px] text-white font-semibold h-[0px]  text-center">
                                  Review
                                </p>
                              </div>

                              <ReviewCardBasic preview={preview} color={'white'} />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div>

                          {/* <div className='mt-5 px-5 flex justify-center'> */}
                          {(socialMedias && socialMedias.length !== 0) ?
                            // <SlideSocialMedia preview={preview} color={'white'} />
                            <SlideSocialMedias preview={preview} color={'white'} />
                            : ""}

                          {/* </div> */}
                        </div>
                      </div>
                      <div className={fileName?.fileName1 || fileName?.fileName2 || fileName?.fileName3 || fileName?.fileName4 ? "border-b-[1px] border-white m-[15px]" : ""}>
                        {fileName?.fileName1 || fileName?.fileName2 || fileName?.fileName3 || fileName?.fileName4 ?
                          <>

                            <div className="p-3">
                              <h3 className="text-center mt-[20px] text-[20px] text-white font-semibold uppercase">
                                Downloads
                              </h3>
                              <div className="flex justify-center items-center">
                                <DownloadBasic files={files} fileName={fileName} preview={preview} color={"white"} />
                              </div>
                            </div>
                          </>
                          : ''
                        }

                      </div>

                      <div className={`${HighlightImageCheck ? ' m-[15px]' : ''}`}>
                        <div className="text-center m-[15px] mb-0">
                          <p className="text-white text-[20px] pt-5 font-semibold">
                            {HighlightImageCheck ? "Gallery" : ""}
                          </p>
                          <div className="grid gap-3 grid-cols-2 items-center ">
                            {HighlightImageCheck && <HighlightImage preview={preview} />}
                          </div>
                        </div>
                      </div>
                      {/*  --------------------------------- footer ---------------------------------  */}
                      {footerText &&
                        <Footer color={"#ffffff"} />
                      }

                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
        {
          preview ?


            <FloatButton.Group className="shadow-xl"
              trigger="click"
              color="black share_button"
              style={{
                left: "50%",
                color: "white",
                position: "fixed",
                bottom: 20,
                marginLeft: '-20px',

              }}
              icon={<MenuOutlined />}
            >



              {card?.exchangeContact?.show ? (
                <div onClick={(e) => e.stopPropagation()} className='mb-[12px]'>
                  <FloatButton
                    icon={
                      <ExchangeContact
                        customButton={exchangeButton}
                        details={card?.exchangeContact}
                        cardId={card._id}
                      />
                    }
                  />
                </div>
              ) : (
                ""
              )}
              <FloatButton
                icon={<ShareAltOutlined />}
                onClick={handleShare}
              />
              <FloatButton
                icon={<QrcodeOutlined />}
                onClick={() => setQrModal(true)}
              />
              <Link to={contactDetails?.locationUrl} target={`${preview ? "_blank" : ""}`}>
                <FloatButton icon={<FaLocationArrow />} />
              </Link>

            </FloatButton.Group>

            : ""}
        {qrModal ? <QRModal handleClose={handleClose} /> : null}
      </div>

    </>
  );
}

export default PrismTheme;
